import SupportValidator from '@/utils/validators/domain/Support'
import { faqSearchLengthError } from '@/const/errorMessage'

export interface Fields {
  query: string | null
}

export type FieldErrors = { [key in keyof Fields]: string[] }

export default class FaqSearchValidator {
  static validate(fields: Partial<Fields>): FieldErrors {
    const errors: FieldErrors = {
      query: []
    }
    const validator = new SupportValidator(fields)
    if (fields.query !== undefined) {
      if (!fields.query) {
        errors.query.push(faqSearchLengthError)
      } else if (!validator.isQueryLengthValid()) {
        errors.query.push(faqSearchLengthError)
      }
    }
    return errors
  }
}
